import { useState } from "react";
import { Link } from "react-router-dom";
import { Radio, Mail, ArrowLeft, Loader2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      toast.error("Ingresa tu email");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API_BASE}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success("Revisa tu correo electrónico");
    } catch (error) {
      // Don't reveal if email exists or not
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-[#34C759]/10 mb-4">
            <Radio className="w-8 h-8 text-[#34C759]" />
          </div>
          <h1 className="text-2xl font-heading font-bold text-[#F4F4F5]">
            AVX RF PRO
          </h1>
          <p className="text-sm text-[#71717A]">ANLEON CHILE</p>
        </div>

        {/* Card */}
        <div className="bg-[#0A0A0A] border border-white/[0.08] rounded-lg p-6">
          {!submitted ? (
            <>
              <div className="text-center mb-6">
                <h2 className="text-xl font-heading font-semibold text-[#F4F4F5] mb-2">
                  ¿Olvidaste tu contraseña?
                </h2>
                <p className="text-sm text-[#71717A]">
                  Ingresa tu email y te enviaremos un enlace para restablecerla
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="form-group">
                  <Label htmlFor="email" className="form-label">
                    Email
                  </Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#71717A]" />
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="input-tactical pl-10"
                      placeholder="tu@email.com"
                      autoComplete="email"
                      data-testid="forgot-email-input"
                    />
                  </div>
                </div>

                <Button
                  type="submit"
                  className="w-full btn-primary"
                  disabled={loading}
                  data-testid="forgot-submit-button"
                >
                  {loading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Enviando...
                    </>
                  ) : (
                    "Enviar enlace de recuperación"
                  )}
                </Button>
              </form>
            </>
          ) : (
            /* Success State */
            <div className="text-center py-4">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#34C759]/10 mb-4">
                <CheckCircle2 className="w-8 h-8 text-[#34C759]" />
              </div>
              <h2 className="text-xl font-heading font-semibold text-[#F4F4F5] mb-2">
                ¡Revisa tu correo!
              </h2>
              <p className="text-sm text-[#71717A] mb-4">
                Si el email <span className="text-[#F4F4F5]">{email}</span> está registrado, 
                recibirás un enlace para restablecer tu contraseña.
              </p>
              <p className="text-xs text-[#71717A]">
                El enlace expira en 1 hora. Revisa también tu carpeta de spam.
              </p>
            </div>
          )}

          {/* Back to login */}
          <div className="mt-6 pt-4 border-t border-white/[0.08] text-center">
            <Link
              to="/login"
              className="inline-flex items-center gap-2 text-sm text-[#34C759] hover:text-[#34C759]/80 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Volver al inicio de sesión
            </Link>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-[#71717A] mt-6">
          © 2026 AVX RF PRO - Anleon Chile
        </p>
      </div>
    </div>
  );
}
